<ng-content></ng-content>
<atlas-notifications
  [userId]="userId$ | async"
  *ngIf="notificationsEnabled$ | async"
  [partnerId]="partnerId$ | async"
></atlas-notifications>
<atlas-center-selector
  *ngIf="(hideCenters$ | async) === false"
  [centerData]="centerData$ | async"
  [serviceProviderId]="serviceProviderId$ | async"
></atlas-center-selector>
<ng-container *ngIf="(hideUserDropdown$ | async) === false">
  <div class="atlas-navbar__divider atlas-navbar__divider__display"></div>
  <atlas-user-dropdown
    [username]="username$ | async"
    [email]="email$ | async"
    [menuItems]="userNavigationItems$ | async"
    [signOutUrl]="signOutUrl$ | async"
    [extraMenuItems]="dropdownItems$ | async"
    [showLanguageSelector]="showLanguageSelector$ | async"
    [impersonateeUsername]="impersonateeUsername$ | async"
    [userSwitcherData]="userSwitcherData$ | async"
    [partnerName]="partnerName$ | async"
    (event)="propagateEvent($event)"
  ></atlas-user-dropdown>
</ng-container>
